import styled from '@emotion/styled'
import {theme} from '../../../../../../core/theme'
// ── Styled components ─────────────────────────────────────────────────────────

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${theme.colors.bg.primary};
  padding: 10px;
  width: 100%;
`

// ── Left side ──────────────────────────────────────────────────────────────

export const BrandSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  min-width: 0;
`

export const LogoMark = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  //   border-radius: ${theme.radii.md};
  //   background: ${theme.colors.bg.tertiary};
  color: ${theme.colors.text.primary};
  flex-shrink: 0;
`

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
`

export const Title = styled.h1`
  font-family: ${theme.fonts.heading};
  font-size: ${theme.fontSizes.xl};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  line-height: 1.25;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Subtitle = styled.p`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.text.secondary};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    color: ${theme.colors.text.muted};
  }
`

// ── Right side actions ────────────────────────────────────────────────────

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  flex-shrink: 0;
`

// Wraps the Send Proposal button so clicks are still captured while it is
// disabled — a disabled <button> never fires click events of its own.
export const SendActionWrap = styled.span`
  display: inline-flex;
  cursor: ${({isDisabled}) => (isDisabled ? 'not-allowed' : 'default')};

  ${({isDisabled}) =>
    isDisabled &&
    `
    & > button {
      pointer-events: none;
    }
  `}
`
